export default __webpack_public_path__ + "static/media/empty-box.79ba08c5.svg";